import { useState, useEffect } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ScrollToTop from "@/components/base/ScrollToTop";

function ConditionalScrollToTop() {
  const { pathname } = useLocation();
  if (pathname === "/") return null;
  return <ScrollToTop />;
}

function SplashScreen({ onComplete }: { onComplete: () => void }) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!visible) {
      const timer = setTimeout(onComplete, 500);
      return () => clearTimeout(timer);
    }
  }, [visible, onComplete]);

  return (
    <div
      className={`fixed inset-0 z-[9999] bg-background-50 flex flex-col items-center justify-center transition-opacity duration-500 ${
        visible ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
    >
      <img
        src="https://storage.readdy-site.link/project_files/46c769b0-62ed-4752-96b8-d59840c4cf62/9748f6f8-69f8-4cd8-80d4-a7226d6e517f_compressed_2RwFCLTUpy3e95i1783055771_1783055772.webp"
        alt="ファクトケイ"
        className="w-32 h-32 object-contain"
      />
    </div>
  );
}

function App() {
  const [showSplash, setShowSplash] = useState(true);

  if (showSplash) {
    return (
      <I18nextProvider i18n={i18n}>
        <SplashScreen onComplete={() => setShowSplash(false)} />
      </I18nextProvider>
    );
  }

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ConditionalScrollToTop />
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;